<p-chart
  type="bar"
  [data]="basicData"
  [options]="basicOptions"
  [style.background-color]="bgColor" />
